import {defineStore} from "pinia";
import {computed, ref} from "vue";

export const useHintStore = defineStore('hints', () => {
    const tapApi = useTapApi();

    const hints = ref({})
    let initPromise = null;

    const checkHint = async (code) => {
        if(hints.value[code] && hints.value[code]['request']) {
            return true
        }
        if(!hints.value[code]) {
            hints.value[code] = { request: true }
        } else {
            hints.value[code].request = true
        }

        if (hints.value[code].hasOwnProperty('response')) {
            return hints.value[code].response
        }

        if (!initPromise) {
            initPromise = tapApi.checkHint().then(response => {
                response.forEach(hint => {
                    if (!hints.value[hint.code]) hints.value[hint.code] = {};
                    hints.value[hint.code].response = hint.viewed;
                    hints.value[hint.code].id = hint.id;
                });
                return hints.value[code]?.response
            })

            return initPromise;
        }

        await initPromise;
        return hints.value[code]?.response
    };

    const viewHint = (code) => {
        if(!hints.value[code]['response']) {
            hints.value[code]['response'] = true
            tapApi.viewHint(code)
        }
        hints.value[code]['show'] = true;
    }

    const canShow = (code) => {
        if(!visibleHints.value.length) return false
        return visibleHints.value[0][0] === code
    }

    const visibleHints = computed(() =>
        Object.entries(hints.value)
         .filter(([, hint]) => hint.show)
         .sort(([, a], [, b]) => a.id - b.id)
    )

    const closeHint = (code) => {
        hints.value[code]['show'] = false;
    }

    const clearHints = () => {
        hints.value = {}
        initPromise = null
    }

    return {
        checkHint,
        viewHint,
        canShow,
        closeHint,
        clearHints
    }
})
